import $ from 'jquery';
import 'bootstrap';
import select2 from 'select2';

import GaleriaEmpreendimento from './components/GaleriaEmpreendimento';
import SmoothScroll from './components/SmoothScroll';
import getYoutubeId from './util/getYoutubeId';
import LazyLoad from './components/Lazyload';
import NavbarSticker from './components/NavbarSticker';
import taxRegiao from './routes/taxonomia-regiao';
import './modules/app.setpar';

import '../styles/empreendimento.scss';
import Router from './util/Router';

const routes = new Router({
  taxRegiao,
});

$(document).ready(() => {
  routes.loadEvents();
  GaleriaEmpreendimento.init();
  SmoothScroll.init();
  LazyLoad.init();
  NavbarSticker.init();

  $('.js-show-andamento').on('click', (event) => {
    const theModal = $(event.target).data('target');
    const videoSRC = $(event.target).attr('data-video');
    const videoId = getYoutubeId(videoSRC);
    const videoSRCauto = `//www.youtube.com/embed/${videoId}?modestbranding=1&rel=0&controls=1&showinfo=0&html5=1&autoplay=1`;

    $(`${theModal} iframe`).attr('src', videoSRCauto);
    $(theModal).on('hide.bs.modal', () => {
      $(`${theModal} iframe`).attr('src', videoSRC);
    });
  });

  // Fechar navbar quando clica em um dos items do menu
  $('.navbar-nav>li>a')
    .not('.dropdown-toggle')
    .on('click', function () {
      $('.navbar-collapse').collapse('hide');
    });

  //Inicializa select2
  select2($);
  $('#regioes').select2({
    theme: 'bootstrap4',
    language: {
      noResults: function () {
        return 'Nenhum resultado encontrado';
      },
    },
  });
});
